import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=828aaf04&"
import script from "./NavigationDesktop.vue?vue&type=script&lang=ts&"
export * from "./NavigationDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports